module.exports = __webpack_public_path__ + "static/media/profile-1.04a05ff1.jpg";